import React, { useRef, useState } from "react";
import { AiFillLinkedin, AiFillGithub } from "react-icons/ai";
import { SiHackerrank } from "react-icons/si";
import emailjs from "@emailjs/browser";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Contact = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: "",
  });
  const formRef = useRef();
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    // Check if any of the fields are empty
    if (!form.name || !form.email || !form.message) {
      toast.error("Please fill in all fields.");
      return;
    }
    setLoading(true);

    emailjs
      .sendForm("service_lwdu4fx", "template_v6cwuvl", formRef.current, {
        publicKey: "3Z-Z_L3pSgkbM33wf",
      })
      .then(
        () => {
          setLoading(false);
          setSuccess(true);
          setForm({
            name: "",
            email: "",
            message: "",
          });
          toast.success("Message sent successfully!");
        },
        (error) => {
          setLoading(false);
          setError(true);
          toast.error("Error sending message. Please try again.");
        }
      );
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  };

  return (
    <div
      className="px-6 pt-16 sm:pt-16 sm:pb-16 lg:pb-96 md:h-[100vh]"
      id="contact"
    >
      <ToastContainer />
      <div
        class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10
                     bg-black/40 rounded-xl md:rounded-xl"
      >
        <div class="mb-4">
          <div class="mb-6 max-w-3xl text-center sm:text-center md:mx-auto ">
            <h2 class="mb-4 font-bold tracking-tight text-gray-200 text-3xl sm:text-5xl">
              Let´s connect
            </h2>
            <p class="mx-auto mt-4 max-w-3xl text-xl text-gray-400">
              and start working on amazing things
            </p>
          </div>
        </div>

        <div class="flex justify-center">
          <div class="grid md:grid-cols-2">
            <div class="my-auto pr-6">
              <ul className="flex px-10 gap-10">
                <li class="flex">
                  <a
                    className="cursor-pointer"
                    href="https://www.linkedin.com/in/pradicksha-pradeepraj-b269721bb/"
                  >
                    <AiFillLinkedin className="w-[70px] h-auto text-gray-300" />
                  </a>
                </li>
                <li class="flex">
                  <a
                    className="cursor-pointer"
                    href="https://github.com/Pradi-Hub"
                  >
                    <AiFillGithub className="w-[70px] h-auto text-gray-300" />
                  </a>
                </li>
                <li class="flex">
                  <a
                    className="cursor-pointer"
                    href="https://www.hackerrank.com/profile/pradicksha1230"
                  >
                    <SiHackerrank className="w-[62px] h-auto text-gray-300" />
                  </a>
                </li>
              </ul>
            </div>
            <div class="max-w-6xl p-5 md:p-12" id="form">
              <h2 class="mb-4 text-2xl font-bold text-gray-300">
                Ready to Get Started?
              </h2>
              <form ref={formRef} method="POST" onSubmit={sendEmail}>
                <div class="mb-6">
                  <div class="mx-0 mb-1 sm:mb-4">
                    <div class="mx-0 mb-1 sm:mb-4">
                      <input
                        type="text"
                        id="name"
                        autoComplete="given-name"
                        placeholder="Your name"
                        class="mb-2 w-full rounded-md border border-gray-400 py-2 pl-2 pr-4 sm:mb-0"
                        name="name"
                        value={form.name}
                        onChange={handleChange}
                      />
                    </div>
                    <div class="mx-0 mb-1 sm:mb-4">
                      <input
                        type="email"
                        id="email"
                        autoComplete="email"
                        placeholder="Your email address"
                        class="mb-2 w-full rounded-md border border-gray-400 py-2 pl-2 pr-4 sm:mb-0"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div class="mx-0 mb-1 sm:mb-4">
                    <textarea
                      id="message"
                      name="message"
                      cols="30"
                      rows="5"
                      placeholder="Write your message..."
                      class="mb-2 w-full rounded-md border border-gray-400 py-2 pl-2 pr-4 sm:mb-0"
                      value={form.message}
                      onChange={handleChange}
                    ></textarea>
                  </div>
                </div>
                <div class="text-center">
                  <button
                    type="submit"
                    class="z-50 w-full bg-gray-800 text-white px-6 py-3 font-xl rounded-md sm:mb-0"
                    disabled={loading}
                  >
                    {loading ? "Sending" : "Send Message"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
